import { render } from "./rental_body_details.vue?vue&type=template&id=e80f83f6&scoped=true"
import script from "./rental_body_details.vue?vue&type=script&lang=js"
export * from "./rental_body_details.vue?vue&type=script&lang=js"

import "./rental_body_details.vue?vue&type=style&index=0&id=e80f83f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80f83f6"]])

export default __exports__